module.exports = __webpack_public_path__ + "static/institutionLogoNebraska-01e6470f8e01da1e9f8e30a268e1f4a2.png";